import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    violetBlue: {
      main: "#464FC0ff",
      dark: "#1e236e",
      light: "#8c94fe",
    },
    aliceBlue: {
      main: "#E4F2FCff",
    },
    periwinkleCrayola: {
      main: "#D4DBFBff",
      light: "#F4F5FE",
    },
    bleuDeFrance: {
      main: "#1E88E5ff",
    },
    primary: {
      main: "#E4572E",
    },
    secondary: {
      main: "#464FC0ff",
    },
    green: "#119b49",
  },
  background: {
    paper: "#ffffff",
  },
  typography: {
    fontFamily: "Product Sans",
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#E4572E",
        },
      },
    },
  },
});
export const NavLinkFontSizes = {
  fontSize: {
    sm: "20rem",
    xs: "16rem",
  },
};
export const HomePHeaderSizes = {
  fontSize: {
    xs: 24,
    md: 50,
  },
};
export const HomePHeaderSizes2 = {
  fontSize: {
    xs: 20,
    md: 46,
  },
};
